/* tslint:disable:all */
/**
* Environment file
* NOTE: use 'dev' if you want to run Cajita locally
*/

export const environment: {
env: string;
envName: string;
gaID: string;
gaTestMode: boolean;
rollbarId: string,
} = {
env: 'test',
envName: "",
gaID: "UA-150385097-6",
gaTestMode: true,
rollbarId: '',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts